import { Bounds, Position } from "./types";

const r_earth = 6371000;

function toRad(Value: number) {
  return (Value * Math.PI) / 180;
}

export function distance(pos1: Position, pos2: Position): number {
  const R = 6371; // km
  const dLat = toRad(pos2.lat - pos1.lat);
  const dLon = toRad(pos2.lon - pos1.lon);
  const lat1 = toRad(pos1.lat);
  const lat2 = toRad(pos2.lat);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c * 1000;
}

export function getBounds(center: Position, radius: number): Bounds {
  const { lat, lon } = center;
  const lat_distance = (radius / r_earth) * (180 / Math.PI);
  const lon_distance =
    ((radius / r_earth) * (180 / Math.PI)) / Math.cos((lat * Math.PI) / 180);
  const minlat = lat - lat_distance;
  const maxlat = lat + lat_distance;
  const minlon = lon - lon_distance;
  const maxlon = lon + lon_distance;
  return {
    minlat,
    minlon,
    maxlat,
    maxlon,
  };
}
